import { useRouter } from '@application/utils';
import { Button, Section } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import * as RootStyled from '../../styled';
import { FeatureList } from '../FeatureList';
import feature1FRMobile from '../assets/feature1FR-mobile.webp';
import feature1FR from '../assets/feature1FR.webp';
import feature1NLMobile from '../assets/feature1NL-mobile.webp';
import feature1NL from '../assets/feature1NL.webp';
import feature1DEMobile from '../assets/feature1DE-mobile.webp';
import feature1DE from '../assets/feature1DE.webp';
import feature2FRMobile from '../assets/feature2FR-mobile.webp';
import feature2FR from '../assets/feature2FR.webp';
import feature2DEMobile from '../assets/feature2DE-mobile.webp';
import feature2DE from '../assets/feature2DE.webp';
import feature2NLMobile from '../assets/feature2NL-mobile.webp';
import feature2NL from '../assets/feature2NL.webp';
import feature3FRMobile from '../assets/feature3FR-mobile.webp';
import feature3FR from '../assets/feature3FR.webp';
import feature3DEMobile from '../assets/feature3DE-mobile.webp';
import feature3DE from '../assets/feature3DE.webp';
import feature3NLMobile from '../assets/feature3NL-mobile.webp';
import feature3NL from '../assets/feature3NL.webp';
import feature4FRMobile from '../assets/feature4FR-mobile.webp';
import feature4FR from '../assets/feature4FR.webp';
import feature4DEMobile from '../assets/feature4DE-mobile.webp';
import feature4DE from '../assets/feature4DE.webp';
import feature4NLMobile from '../assets/feature4NL-mobile.webp';
import feature4NL from '../assets/feature4NL.webp';
import feature5FRMobile from '../assets/feature5FR-mobile.webp';
import feature5FR from '../assets/feature5FR.webp';
import feature5DEMobile from '../assets/feature5DE-mobile.webp';
import feature5DE from '../assets/feature5DE.webp';
import feature5NLMobile from '../assets/feature5NL-mobile.webp';
import feature5NL from '../assets/feature5NL.webp';
import * as Styled from './styled';

export const FeaturesSection: FC = () => {
  const { translate } = useTranslation({ keyPrefix: 'breederLanding.features' });
  const { routeLocationDescriptor } = useRouter();

  const FEATURES = [
    {
      title: translate('feature1.title'),
      text: translate('feature1.text'),
      image: {
        fr: [feature1FR, feature1FRMobile],
        nl: [feature1NL, feature1NLMobile],
        de: [feature1DE, feature1DEMobile],
        en: [feature1DE, feature1DEMobile],
      },
    },
    {
      title: translate('feature2.title'),
      text: translate('feature2.text'),
      image: {
        fr: [feature2FR, feature2FRMobile],
        nl: [feature2NL, feature2NLMobile],
        de: [feature2DE, feature2DEMobile],
        en: [feature2DE, feature2DEMobile],
      },
    },
    {
      title: translate('feature3.title'),
      text: translate('feature3.text'),
      image: {
        fr: [feature3FR, feature3FRMobile],
        nl: [feature3NL, feature3NLMobile],
        de: [feature3DE, feature3DEMobile],
        en: [feature3DE, feature3DEMobile],
      },
    },
    {
      title: translate('feature4.title'),
      text: translate('feature4.text'),
      image: {
        fr: [feature4FR, feature4FRMobile],
        nl: [feature4NL, feature4NLMobile],
        de: [feature4DE, feature4DEMobile],
        en: [feature4DE, feature4DEMobile],
      },
    },
    {
      title: translate('feature5.title'),
      text: translate('feature5.text'),
      image: {
        fr: [feature5FR, feature5FRMobile],
        nl: [feature5NL, feature5NLMobile],
        de: [feature5DE, feature5DEMobile],
        en: [feature5DE, feature5DEMobile],
      },
    },
  ];

  return (
    <Styled.Container>
      <RootStyled.Title>{translate('title')}</RootStyled.Title>

      <Styled.ListWrapper>
        <FeatureList items={FEATURES} />
      </Styled.ListWrapper>

      <Section centerChildren>
        <Button color="blue" shrink size="large" link={routeLocationDescriptor('joinBreeder')}>
          {translate('button')}
        </Button>
      </Section>
    </Styled.Container>
  );
};
